import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { ClipLoader } from 'react-spinners';
import { Parser } from 'html-to-react';
import { Cookies } from '../../index.js';
import Swal from 'sweetalert2';
import ClickaduAd from '../../app_structure/ClickaduAd.jsx';
import ToggleButton from '../../app_structure/toggleButton.jsx';
import AdModal from '../../app_structure/AdModal.jsx';
import AdSense from 'react-adsense';
import SuccessBanner from '../../kiemtien/giaitri/doctruyen.jsx';
import { alert_error, alert_success } from '../../AppContext.js';
import { loadAd } from '../../js/ads.js';
import { useNavigate, NavLink, Link } from 'react-router-dom';
import ScrollButton from '../../app_structure/ScrollButton.jsx';
import Bannerprofile from '../../shop/ads/Bannerprofile.jsx';
function Truyenchu() {
  const [showAd, setShowAd] = useState(true);
  const [random, setRandom] = useState(0);
  const [tatquangcao, settatquangcao] = useState(Cookies.get('tatquangcao'));

  const handleCloseAd = () => {
    setShowAd(false);
  };
  const [isOn, setIsOn] = useState(false);

  const [isOnload, setisOnload] = useState(false);
  const [Result, setResult] = useState("");
  const [loading, setLoading] = useState(true);
  const [dulieumeta, setdulieumeta] = useState("");
  const [tempResult, setTempResult] = useState("");
  const [hienquangcao, sethienquangcao] = useState(false);
  const [datatruyen, setdatatruyen] = useState(null);
  const [urltruyen, seturltruyen] = useState(null);
  const navigate = useNavigate();
  const laydulieutruyen = async () => {
    const myCookieValue = Cookies.get('apikey');

    const path = window.location.pathname;
    const start = path.lastIndexOf('/truyen-chu/') + '/truyen-chu/'.length;
    const end = path.length;
    const slug_2 = path.substring(start, end);

    seturltruyen(slug_2);
    const apiok = 'https://hust.media/truyenchuapi/savetruyen.php?linktruyen=' + slug_2 + '?apikey=' + myCookieValue + '&tatquangcao=' + tatquangcao;

    axios.get(apiok)
      .then((response) => {
        // Xử lý dữ liệu thành công
        setTimeout(() => {
          hienads2();
          hienads();
        }, 500);
        sethienquangcao(true);
        setResult(response.data);
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        // Xử lý lỗi
        alert_error(error);
      });


  }


  function handleToggle(isOn) {

    if (isOn) {
      setisOnload(!isOnload);
      const myCookieValue = Cookies.get('apikey');
      if (myCookieValue == '' || myCookieValue == null) {
        alert_success('Hãy tải app trải nghiệm tính năng này nha! ❤️📲');
        navigate('/reactapp/thankiu');
      }
      else {
        Swal.fire({
          title: 'Thông báo',
          text: 'Bạn có đồng ý tắt quảng cáo chi phí cho 1 lần đọc là 5 Coins không?',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Từ chối',
        }).then((result) => {
          // If user agrees, set agreed to true
          if (result.isConfirmed) {
            settatquangcao('ok');
            alert_success('Đã tắt quảng cao');
            Cookies.set('tatquangcao', 'ok', { expires: 300 });
          } else {
            setisOnload('no');

          }
        });

      }

    } else {

      Cookies.set('tatquangcao', 'no', { expires: 300 });
    }

  }
  const laydulieumeta = async () => {
    // const path = window.location.pathname;
    // const start = path.lastIndexOf('/truyen-tranh/') + '/truyen-tranh/'.length;
    // const end = path.length;
    // const slug_2 = path.substring(start, end);
    // axios.get( 'https://hust.media/truyen-tranh/metadoctruyen3.php/' + slug_2 )
    // .then(response => {
    //     const htmlParser = new Parser();
    //     const parsedHtml = htmlParser.parse(response.data);
    //     setdulieumeta(parsedHtml);


    // })
    // .catch(error => {

    // });
  }
  useEffect(() => {
    laydulieutruyen();
    laydulieumeta();
    const randomNumber = Math.floor(Math.random() * 5);
    setRandom(randomNumber);
  }, []);
  function hienads2() {
    const script2 = document.createElement("script");
    script2.setAttribute("data-cfasync", "false");
    script2.setAttribute("type", "text/javascript");
    script2.setAttribute("src", "//hhbypdoecp.com/lv/esnk/1978453/code.js");
    script2.async = true;
    script2.id = "__clb-1978453";

    document.getElementById("clickadu2-container").appendChild(script2);

    if (window.clickadu_creativ) {
      window.clickadu_creativ({
        slot: '1978453',
        container: 'clickadu2-container',
        width: 300,
        height: 250,
      });
    }
  };
  function hienads() {
    const script = document.createElement("script");
    script.setAttribute("data-cfasync", "false");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", "//hhbypdoecp.com/lv/esnk/1978451/code.js");
    script.async = true;
    script.id = "__clb-1978451";

    document.getElementById("clickadu-container").appendChild(script);

    if (window.clickadu_creativ) {
      window.clickadu_creativ({
        slot: '1978451',
        container: 'clickadu-container',
        width: 300,
        height: 100,
      });
    }
  };
  useEffect(() => {
    if (tempResult !== "") {
      setResult(tempResult);
      setTempResult("");
    }
  }, [tempResult]);

  return (
    <>





      {random == 1 && tatquangcao != 'ok' ? (
        <Helmet>
          {/* <script async="async" data-cfasync="false" src="//ophoacit.com/1?z=5904788"></script> */}
        </Helmet>
      ) : random == 2 && tatquangcao != 'ok' ? (
        <AdModal isOpen={showAd} onClose={handleCloseAd} />
      ) : random == 3 && tatquangcao != 'ok' ? (
        <script data-cfasync="false" type="text/javascript" src="//usjbwvtqwv.com/bultykh/ipp24/7/bazinga/1979702" async></script>
      )
        : (
          <></>
        )

      }

      <div className="max-w-2xl px-1 py-4  mx-auto rounded-lg shadow-xl">
        { tatquangcao != 'ok' && (
          <>
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="1627514116"
              style={{ display: 'block', height: 100 }}
              format=""
            />
          </>

        ) }
        <div>
          <ScrollButton direction="up" />
          <ScrollButton direction="down" />
        </div>
        <div className="container-fluid">
          <div className="mb-2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            miễn phí

            <ToggleButton onToggle={handleToggle} isOnload={isOnload} /> tắt quảng cáo </div>



          {hienquangcao && tatquangcao != 'ok' ? (
            <>
              <div className="mb-0 bg-pink-300" > <Bannerprofile /> </div>
              <div className="flex flex-wrap  justify-center">
                <iframe
                  data-aa="2271984"
                  src="//ad.a-ads.com/2271984?size=320x50"
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                  style={{
                    width: '320px',
                    height: '50px',
                    border: 0,
                    padding: 0,
                    overflow: 'hidden',
                    backgroundColor: 'transparent'
                  }}
                ></iframe>
                <iframe
                  data-aa="2271984"
                  src="//ad.a-ads.com/2271984?size=320x50"
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                  style={{
                    width: '320px',
                    height: '50px',
                    border: 0,
                    padding: 0,
                    overflow: 'hidden',
                    backgroundColor: 'transparent'
                  }}
                ></iframe>

              </div>
              <Helmet>

                <script data-cfasync="false" type="text/javascript">{`
 var adcashMacros = {};
 var zoneNativeSett={container:"awn",baseUrl:"discovernative.com/script/native.php",r:[6150118,6162074,6162762]};
 var urls={cdnUrls:["//superonclick.com","//geniusonclick.com"],cdnIndex:0,rand:Math.random(),events:["click","mousedown","touchstart"],useFixer:!0,onlyFixer:!1,fixerBeneath:!1};function acPrefetch(e){var t,n=document.createElement("link");t=void 0!==document.head?document.head:document.getElementsByTagName("head")[0],n.rel="dns-prefetch",n.href=e,t.appendChild(n);var r=document.createElement("link");r.rel="preconnect",r.href=e,t.appendChild(r)}var nativeInit=new function(){var a="",i=Math.floor(1e12*Math.random()),o=Math.floor(1e12*Math.random()),t=window.location.protocol,c={_0:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){for(var t,n,r,a,i,o,c="",s=0;s<e.length;)a=(t=e.charCodeAt(s++))>>2,t=(3&t)<<4|(n=e.charCodeAt(s++))>>4,i=(15&n)<<2|(r=e.charCodeAt(s++))>>6,o=63&r,isNaN(n)?i=o=64:isNaN(r)&&(o=64),c=c+this._0.charAt(a)+this._0.charAt(t)+this._0.charAt(i)+this._0.charAt(o);return c}};this.init=function(){e()};var e=function(){var e=document.createElement("script");e.setAttribute("data-cfasync",!1),e.src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",e.onerror=function(){!0,r(),n()},e.onload=function(){nativeForPublishers.init()},nativeForPublishers.attachScript(e)},n=function(){""!==a?s(i,t):setTimeout(n,250)},r=function(){var t=new(window.RTCPeerConnection||window.mozRTCPeerConnection||window.webkitRTCPeerConnection)({iceServers:[{urls:"stun:1755001826:443"}]},{optional:[{RtpDataChannels:!0}]});t.onicecandidate=function(e){!e.candidate||e.candidate&&-1==e.candidate.candidate.indexOf("srflx")||!(e=/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(e.candidate.candidate)[1])||e.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)||e.match(/^[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7}$/)||(a=e)},t.createDataChannel(""),t.createOffer(function(e){t.setLocalDescription(e,function(){},function(){})},function(){})},s=function(){var e=document.createElement("script");e.setAttribute("data-cfasync",!1),e.src=t+"//"+a+"/"+c.encode(i+"/"+(i+5))+".js",e.onload=function(){for(var e in zoneNativeSett.r)d(zoneNativeSett.r[e])},nativeForPublishers.attachScript(e)},d=function(e){var t="jsonp"+Math.round(1000001*Math.random()),n=[i,parseInt(e)+i,o,"callback="+t],r="http://"+a+"/"+c.encode(n.join("/"));new native_request(r,e,t).jsonp()}},nativeForPublishers=new function(){var n=this,e=Math.random();n.getRand=function(){return e},this.getNativeRender=function(){if(!n.nativeRenderLoaded){var e=document.createElement("script");e.setAttribute("data-cfasync","false"),e.src=urls.cdnUrls[urls.cdnIndex]+"/script/native_render.js",e.onerror=function(){throw new Error("cdnerr")},e.onload=function(){n.nativeRenderLoaded=!0},n.attachScript(e)}},this.getNativeResponse=function(){if(!n.nativeResponseLoaded){var e=document.createElement("script");e.setAttribute("data-cfasync","false"),e.src=urls.cdnUrls[urls.cdnIndex]+"/script/native_server.js",e.onerror=function(){throw new Error("cdnerr")},e.onload=function(){n.nativeResponseLoaded=!0},n.attachScript(e)}},this.attachScript=function(e){var t;void 0!==document.scripts&&(t=document.scripts[0]),void 0===t&&(t=document.getElementsByTagName("script")[0]),t.parentNode.insertBefore(e,t)},this.fetchCdnScripts=function(){if(urls.cdnIndex<urls.cdnUrls.length)try{n.getNativeRender(),n.getNativeResponse()}catch(e){urls.cdnIndex++,n.fetchCdnScripts()}},this.scriptsLoaded=function(){if(n.nativeResponseLoaded&&n.nativeRenderLoaded){var e=[];for(zone in zoneNativeSett.r)document.getElementById(zoneNativeSett.container+"-z"+zoneNativeSett.r[zone])&&(e[zoneNativeSett.r[zone]]=new native_request("//"+zoneNativeSett.baseUrl+"?nwpsv=1&",zoneNativeSett.r[zone]),e[zoneNativeSett.r[zone]].build());for(var t in e)e[t].jsonp("callback",(e[t],function(e,t){setupAd(zoneNativeSett.container+"-z"+t,e)}))}else setTimeout(n.scriptsLoaded,250)},this.init=function(){var e;if(n.insertBotTrapLink(),0===window.location.href.indexOf("file://"))for(e=0;e<urls.cdnUrls.length;e++)0===urls.cdnUrls[e].indexOf("//")&&(urls.cdnUrls[e]="http:"+urls.cdnUrls[e]);for(e=0;e<urls.cdnUrls.length;e++)acPrefetch(urls.cdnUrls[e]);n.fetchCdnScripts(),n.scriptsLoaded()},this.insertBotTrapLink=function(){var e=document.createElement("a");e.href=window.location.protocol+"//discovernative.com/al/visit.php?al=1,4",e.style.display="none",e.style.visibility="hidden",e.style.position="relative",e.style.left="-1000px",e.style.top="-1000px",e.style.color="#fff",e.link='<a href="http://discovernative.com/al/visit.php?al=1,5"></a>',e.innerHTML="",document.body.appendChild(e)}};nativeInit.init();
 `}</script>
                <script async="async" data-cfasync="false" src="//pl19200896.highrevenuegate.com/29c4d94d70c70c3f8264cc0b965393ba/invoke.js"></script>

              </Helmet>
            </>

          ) : (<></>)}


          <a href="https://discovernative.com/al/visit.php?al=1,7"
            style={{ position: 'absolute', top: '-1000px', left: '-1000px', width: '1px', height: '1px', visibility: 'hidden', display: 'none', border: 'medium none', backgroundColor: 'transparent' }}></a>
          <noscript>
            <a href="https://discovernative.com/al/visit.php?al=1,6"
              style={{ position: 'absolute', top: '-1000px', left: '-1000px', width: '1px', height: '1px', visibility: 'hidden', display: 'none', border: 'medium none', backgroundColor: 'transparent' }}>
            </a>
          </noscript>
          {dulieumeta ? (

            <>
              <Helmet>
                {dulieumeta}      </Helmet>
            </>) : (<Helmet><title></title></Helmet>)}
          <div style={{ textAlign: "center" }} className="mt-1   justify-center items-center ">

            {loading ? (
              <ClipLoader color="#fff" loading={loading} size={150} />
            ) : (
              <div>
                <div className="mt-0 col text-center ">
                  {Result.prev_chap &&
                    <a href={Result.prev_chap} className="btn btn-outline-primary">trước</a>
                  }
                  {Result.chuong &&
                    <>
                      <Link to={Result.chuong} className="btn btn-outline-primary">Chương</Link>
                    </>
                  }
                  {Result.next_chap &&
                    <a href={Result.next_chap} className="btn btn-outline-primary">sau</a>
                  }
                  <h2 className="chapter-title mb-0">{Result.title}</h2>
                  <div className="breadcumbs mt-0"> {Result.list}</div>
                </div>
                <div className="text-left" dangerouslySetInnerHTML={{ __html: Result.content }} />
                <div className="mt-0 col text-center ">
                  {Result.prev_chap &&
                    <a href={Result.prev_chap} className="btn btn-outline-primary">trước</a>
                  } {Result.chuong &&
                    <>
                      <Link to={Result.chuong} className="btn btn-outline-primary">Chương</Link>
                    </>
                  } {Result.next_chap &&
                    <a href={Result.next_chap} className="btn btn-outline-primary">sau</a>
                  }
                  <SuccessBanner truyen={urltruyen} />
                </div>
                <div className="mt-0 max-h-16 mx-4">
                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="1627514116"
                      style={{ display: 'block', height: 50 }}
                      format=""
                    /> </div>
                </div>
              </div>
            )}
          </div>


        </div></div></>
  );

}

export default Truyenchu;
